<template>
  <Top />
</template>

<script lang="ts" setup>
import Top from '@/wabunka-src/features/Top/pages/Top/Top.vue';
</script>
